"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CyndinesSoulHarvestAbilityHandler = exports.CyndinesSoulHarvestActorAbilityFactory = exports.CyndinesSoulHarvestAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EffectType_1 = require("../../core/effects/EffectType");
class CyndinesSoulHarvestAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.CyndinesSoulHarvest;
        this.__typeName = "CyndinesSoulHarvest";
    }
}
exports.CyndinesSoulHarvestAbilityArgs = CyndinesSoulHarvestAbilityArgs;
let CyndinesSoulHarvestActorAbilityFactory = class CyndinesSoulHarvestActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("CyndinesSoulHarvest", "AllEnemies", 4);
    }
};
CyndinesSoulHarvestActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("CyndinesSoulHarvest")
], CyndinesSoulHarvestActorAbilityFactory);
exports.CyndinesSoulHarvestActorAbilityFactory = CyndinesSoulHarvestActorAbilityFactory;
let CyndinesSoulHarvestAbilityHandler = class CyndinesSoulHarvestAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
            effect: new core_1.CyndineSoulHarvestEffectArgs(),
            hidden: true
        });
    }
    activate(sequence, container, ability) {
        const livingEnemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
            .filter(targetId => !container.hasEffectOfType(targetId, EffectType_1.EffectType.Summoned));
        const selectedTargets = (0, Random_1.randomElements)(livingEnemies, 2, false);
        if (selectedTargets.length === 0) {
            return;
        }
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyProjectiles({
                    sequence,
                    projectiles: selectedTargets.map((targetId) => ({
                        creatorId: ability.invokerId,
                        targetId: targetId,
                        jitter: 0,
                        path: "line",
                        type: "PurpleBlueMagicBeam",
                        start: "front-hand",
                        end: "chest",
                    })),
                    onProjectile(sequence, projectile, i, all) {
                        const actor = container.getActor(projectile.targetId);
                        const soulArgs = new ActorArgs_1.NpcActorArgs(container.getFaction(ability.invokerId), actor.classType, actor.level, Object.entries(actor.maxAttributeValues).reduce((attributes, [key, value]) => {
                            let multiplier = .5;
                            switch (+key) {
                                case AttributeType_1.AttributeType.Health:
                                    multiplier = 1.75;
                                    break;
                            }
                            attributes[key] = Math.round(value * multiplier);
                            return attributes;
                        }, {}), Object.entries(actor.abilities).reduce((abilities, [key, value]) => {
                            abilities[key] = Registries_1.ActorAbilities.getItem(value.abilityType).mk();
                            return abilities;
                        }, {})).withAi("Rando", {});
                        container.summonCompanion(sequence, ability.invokerId, soulArgs, Duration_1.Duration.Permanent);
                    },
                });
            }
        });
    }
};
CyndinesSoulHarvestAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.CyndinesSoulHarvest)
], CyndinesSoulHarvestAbilityHandler);
exports.CyndinesSoulHarvestAbilityHandler = CyndinesSoulHarvestAbilityHandler;
